import React from 'react';
import { Link } from 'react-router-dom';
import { TRAVEL_MOODS } from '@/data/discoveryData';
import { cn } from '@/lib/utils';

/**
 * Compact horizontally-scrolling mood pill bar.
 * Each pill links to /search?mood=<id> so all pages reuse the same intent.
 */
export const TravelMoodPills = ({ activeMood, onSelect, asLink = true, variant = 'light' }) => {
  const isDark = variant === 'dark';

  return (
    <div className="w-full overflow-x-auto no-scrollbar -mx-1 px-1 py-1" data-testid="mood-pills">
      <div className="flex gap-2 min-w-max">
        {TRAVEL_MOODS.map((m) => {
          const active = activeMood === m.id;
          const className = cn(
            'inline-flex items-center gap-1.5 shrink-0 px-3.5 py-2 rounded-full text-sm font-medium border transition-all',
            active
              ? 'text-white border-transparent shadow-md scale-[1.03]'
              : isDark
                ? 'bg-white/10 backdrop-blur border-white/15 text-white hover:bg-white/20 hover:border-white/30'
                : 'bg-white border-gray-200 text-gray-800 hover:border-gray-400 hover:shadow-sm'
          );
          const style = active ? { backgroundColor: m.color } : undefined;

          const inner = (
            <>
              <span className="text-base leading-none" aria-hidden>{m.emoji}</span>
              <span>{m.label}</span>
            </>
          );

          if (asLink && !onSelect) {
            return (
              <Link key={m.id} to={`/search?mood=${m.id}`} className={className} style={style} data-testid={`mood-pill-${m.id}`}>
                {inner}
              </Link>
            );
          }
          return (
            <button
              key={m.id}
              type="button"
              onClick={() => onSelect?.(active ? null : m.id)}
              className={className}
              style={style}
              data-testid={`mood-pill-${m.id}`}
            >
              {inner}
            </button>
          );
        })}
      </div>
    </div>
  );
};
